import { Navigate, Outlet } from "react-router-dom";

const INVITE_SETUP_COMPLETE_KEY = "inviteSetupComplete";

export const markInviteSetupComplete = () => {
  localStorage.setItem(INVITE_SETUP_COMPLETE_KEY, "true");
};

export const clearInviteSetupComplete = () => {
  localStorage.removeItem(INVITE_SETUP_COMPLETE_KEY);
};

export const isInviteSetupComplete = () =>
  localStorage.getItem(INVITE_SETUP_COMPLETE_KEY) === "true";

const InviteFlowGuard = () => {
  if (isInviteSetupComplete()) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default InviteFlowGuard;
